import { create } from 'zustand';

export type AppDialogVariant = 'confirm' | 'alert' | 'danger' | 'warning' | 'success';

export interface AppDialogRequest {
  variant: AppDialogVariant;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Material Symbols icon name override. */
  icon?: string;
  /** When false, only the primary button is shown (alert / notice). */
  showCancel: boolean;
  resolve: (confirmed: boolean) => void;
}

interface DialogState {
  current: AppDialogRequest | null;
  open: (
    req: Omit<AppDialogRequest, 'resolve'>,
  ) => Promise<boolean>;
  close: (confirmed: boolean) => void;
}

export const useDialogStore = create<DialogState>((set, get) => ({
  current: null,
  open: (req) =>
    new Promise<boolean>((resolve) => {
      set({
        current: {
          ...req,
          resolve,
        },
      });
    }),
  close: (confirmed) => {
    const cur = get().current;
    cur?.resolve(confirmed);
    set({ current: null });
  },
}));
